import { render, staticRenderFns } from "./DocumentosVenta.vue?vue&type=template&id=232fa1b2"
import script from "./DocumentosVenta.vue?vue&type=script&lang=js"
export * from "./DocumentosVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports